/**
 * useNetworkStatus — détecte l'état de connexion réseau de l'appareil en temps réel
 * via @capacitor/network (fonctionne aussi bien sur web que sur Android/iOS).
 */

import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';

export const useNetworkStatus = (): { isOnline: boolean } => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    Network.getStatus()
      .then(status => setIsOnline(status.connected))
      .catch(() => {});

    Network.addListener('networkStatusChange', status => {
      setIsOnline(status.connected);
    }).then(handle => {
      unsubscribe = () => handle.remove();
    });

    return () => unsubscribe?.();
  }, []);

  return { isOnline };
};
